import Layout from "../../../../src/components/layout";
import { Link } from "gatsby";
import React from 'react';
export default {
  Layout,
  Link,
  React
};